import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create an axios instance with default config
const api= axios.create({
  baseURL: API_URL,
  withCredentials: true, // This is important for handling cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;